/**
 * EventBus -- Simple pub/sub for cross-layer communication.
 * Decouples views from services without global state.
 *
 * @module shared/EventBus
 */

class EventBusImpl {
  #listeners = new Map();

  on(event, callback) {
    if (!this.#listeners.has(event)) {
      this.#listeners.set(event, new Set());
    }
    this.#listeners.get(event).add(callback);
    return () => this.off(event, callback);
  }

  off(event, callback) {
    this.#listeners.get(event)?.delete(callback);
  }

  emit(event, data) {
    this.#listeners.get(event)?.forEach(cb => {
      try { cb(data); } catch (e) { console.error(`[EventBus] ${event}:`, e); }
    });
  }
}

export const EventBus = new EventBusImpl();
